const CLEARANCE_TAG_CONTENT_KEY = 'hbg_priceType'

export const clearanceTag = (
  content: {
    key: string
    value: { stringValue?: string }
  }[],
) => {
  const clearanceTagValue = content?.find(
    (contentItem) => contentItem.key === CLEARANCE_TAG_CONTENT_KEY,
  )

  const clearanceTag =
    clearanceTagValue && clearanceTagValue.value?.stringValue
      ? clearanceTagValue.value.stringValue
      : null

  return clearanceTag
}
